import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileProceduresSeeMorePipe } from './profile-procedures.see.more.pipe';
import { ProfileProceduresDescriptionWidthPipe } from './profile-procedures.description.width.pipe';
import { ProfileProceduresNameWidthPipe } from './profile-procedures.name.width.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ProfileProceduresSeeMorePipe,
    ProfileProceduresDescriptionWidthPipe,
    ProfileProceduresNameWidthPipe,
  ],
  exports: [
    ProfileProceduresSeeMorePipe,
    ProfileProceduresDescriptionWidthPipe,
    ProfileProceduresNameWidthPipe,
  ],
})
export class ProfileProceduresPipesModule {}
